// @ts-strict-ignore
import { isAfter, parseISO } from 'date-fns';

import { ApplicantProfile } from 'api/applicantProfile';
import { MainStoreUserEnvironmentState } from 'modules/main/store/ducks/userEnvironment';
import { isDefined } from 'utils/functional';
import {
  NOTIFICATIONS,
  dismissNotification,
  notificationIsDismissed,
} from 'utils/localNotifications';
import { getItem } from 'utils/localStorage';
import { isNonAdmin } from 'utils/userEnvironment';

const NEW_USER_DATE = new Date('2020-11-16T17:00:00Z');
export const dismissResumeDBLoggedOut = () =>
  dismissNotification(NOTIFICATIONS.UPLOAD_RESUME);
export const hasResumeDb = (userEnvironment: MainStoreUserEnvironmentState) =>
  getItem('enableResumeDb') !== false &&
  (userEnvironment.environment?.isUS || userEnvironment.user?.isRecruitable) &&
  CURRENT_LOCALE === 'en';
export const hasWorkHistoryJobs = (profile?: ApplicantProfile) =>
  profile && profile.workHistoryJobs && profile.workHistoryJobs.length > 0;
export const promoteResumeDatabase = ({
  userEnvironment,
  includeDate,
  allowLoggedOut,
}: {
  userEnvironment: MainStoreUserEnvironmentState;
  includeDate?: boolean;
  allowLoggedOut?: boolean;
}) =>
  userEnvironment.isUserLoaded &&
  userEnvironment.isEnvironmentLoaded &&
  hasResumeDb(userEnvironment) &&
  !notificationIsDismissed(NOTIFICATIONS.UPLOAD_RESUME) &&
  ((allowLoggedOut && !userEnvironment.user) ||
    (isNonAdmin(userEnvironment.user) &&
      (!isDefined(userEnvironment.user.isRecruitable) ||
        (userEnvironment.user.isRecruitable &&
          !userEnvironment.user.resumeId)))) &&
  (!includeDate ||
    isAfter(parseISO(userEnvironment.user.created), NEW_USER_DATE));
